import {createStyles} from '@mantine/core';
import React from 'react';

import {FONT_PROXIMA_12, FONT_WEIGHT_PROXIMA_REGULAR} from 'styles/FontConstants';

const useStyles = createStyles((theme) => ({
  root: {
    ...FONT_PROXIMA_12,
    fontWeight: FONT_WEIGHT_PROXIMA_REGULAR,
    color: theme.colors.gray[7],
    padding: theme.spacing.md,
    backgroundColor: theme.colors.gray[0],
    border: `1px solid ${theme.colors.gray[3]}`,
    borderRadius: theme.radius.sm,
    whiteSpace: 'pre-wrap',
    fontFamily: theme.fontFamilyMonospace,
    lineHeight: 1.4,
    overflow: 'visible',
  },
}));

export interface MonacoStaticContentProps {
  value: string;
  className?: string;
}

/** Full-height static code block used when {@link ChatRenderContext} is in export render mode. */
export function MonacoStaticContent({value, className}: MonacoStaticContentProps): JSX.Element {
  const {classes, cx} = useStyles();
  return <div className={cx(classes.root, className)}>{value}</div>;
}
